import itemsImage from 'web-app/assets/images/items.png?sizes[]=300,sizes[]=600,sizes[]=1024&format=webp&rl';
import { FetchError } from 'web-app/services/api';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { Registry, service } from '@ember/service';
import styles from '../login/styles.css';

interface JoinMeetingArgs {
  appointmentId: string;
  token: string;
  email: string;
  passwordless: boolean;
  invalid: boolean;
}

export default class JoinMeeting extends Component<JoinMeetingArgs> {
  @service api!: Registry['api'];
  @service session!: Registry['session'];

  styles = styles;
  images = {
    items: itemsImage,
  };
  @tracked clientAgree = false;
  @tracked clientAgreeDari = false;

  get email() {
    return this.args.email ?? '';
  }

  validateForm() {
    const errors = [];
    if (this.args.invalid) errors.push('This link has expired. Please use the link from your most recent email.');
    if (!this.clientAgree && !this.clientAgreeDari) errors.push('You must agree to the terms policy');
    if (errors.length) {
      return { success: false, errors };
    }

    return { success: true };
  }

  get formValid() {
    return this.validateForm();
  }

  @action
  async joinMeeting(): Promise<FormResult> {
    const validations = this.validateForm();
    if (!validations.success) {
      return { ...validations, message: 'Something is wrong' };
    }

    try {
      // refugee clients skip the password: agreeing here logs them straight in
      if (this.args.passwordless) {
        const result = await this.api.joinMeeting({
          appointmentId: this.args.appointmentId,
          token: this.args.token,
        });

        await this.session.authenticate('authenticator:custom', result);

        if (result.meetingUrl) {
          window.location.href = result.meetingUrl;
        }

        return { success: true };
      }

      const result = await this.api.updateMeeting({
        appointmentId: this.args.appointmentId,
        token: this.args.token,
      });
      if (result.json.text) {
        window.location.href = result.json.text as string;
      }

      return { success: true };
    } catch (error) {
      if (error instanceof FetchError) {
        return {
          success: false,
          errors: [<string>error?.json?.message],
          message: 'We could not take you to your meeting.',
        };
      }

      return {
        success: false,
        errors: ['Something went wrong. Please try again.'],
        message: 'We could not take you to your meeting.',
      };
    }
  }
}
